import { render } from "./purchaseDetail.vue?vue&type=template&id=feb9f118&scoped=true"
import script from "./purchaseDetail.vue?vue&type=script&lang=js"
export * from "./purchaseDetail.vue?vue&type=script&lang=js"

import "./purchaseDetail.vue?vue&type=style&index=0&id=feb9f118&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feb9f118"]])

export default __exports__